import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IInvitation } from '@app/models/signup';

@Component({
  selector: 'app-invitation-b2b-wrong-account',
  templateUrl: './invitation-b2b-wrong-account.component.html',
  styleUrls: ['./invitation-b2b-wrong-account.component.scss']
})
export class InvitationB2bWrongAccountComponent implements OnInit {
  @Input() invitation: IInvitation;

  endpoints = window['ENDPOINTS'];
  account = window['CURRENT_ACCOUNT'];
  user = window['CONST_USER'];
  managerLink: string;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.managerLink = `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/reseller-space/manage-clients`;
  }

  changeAccount(): void {
    // window.location.assign('auth/logout?with_login_redirect=1&redirect=' + window?.['ENDPOINTS']?.initial);
    this.router.navigate(['/change_account']);
  }
}
